import { useState, useCallback, useEffect, useMemo } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import { getCorporateFieldsData } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/api/corporateFieldsApi';
import { FieldsResponse } from 'src/types/CorporateFieldsData';
import { CorporateFieldsContextType } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsContext';
import {
  transformFieldsDataModelToUI,
  TransformedCorporateFields,
} from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/utils/corporateFields.utilities';

export const useCorporateFields = (): CorporateFieldsContextType => {
  const [isLoading, setIsLoading] = useState(true);
  const [corpFieldsData, setCorpFieldsData] =
    useState<TransformedCorporateFields | null>(null);

  const getFieldsData = useCallback(async () => {
    try {
      const responseData: FieldsResponse = await getCorporateFieldsData();
      setCorpFieldsData(transformFieldsDataModelToUI(responseData));
    } catch (error) {
      pushErrorFromAPI(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getFieldsData();
  }, [getFieldsData]);

  const corpFieldsContextValue = useMemo(
    () => ({
      corpFieldsData,
      loading: isLoading,
    }),
    [corpFieldsData, isLoading]
  );

  return corpFieldsContextValue;
};
